"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function SocialFb32Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "32px", height: "32px", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "social-fb-32", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M16,1 C24.2842717,1 31,7.71572834 31,16 C31,24.2842717 24.2842717,31 16,31 C7.71572834,31 1,24.2842717 1,16 C1,7.71572834 7.71572834,1 16,1 Z M19.5987961,8 L17.3457416,8 C14.6394609,8 13.6869203,9.3642458 13.6869203,11.6584782 L13.6869203,13.3469454 L12,13.3469454 L12,16.1591995 L13.6869203,16.1591995 L13.6869203,24.3196729 L17.0634719,24.3196729 L17.0634719,16.158881 L19.3162074,16.158881 L19.6147435,13.3466269 L17.0634719,13.3466269 L17.0672993,11.9390667 C17.0672993,11.2055875 17.1369896,10.8125726 18.1904776,10.8125726 L19.5987961,10.8125726 L19.5987961,8 Z", id: "fb-grey", fill: "#000000" })));
}
function SocialFb32(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(SocialFb32Svg, Object.assign({}, svgProps)));
}
exports.default = SocialFb32;
//# sourceMappingURL=SocialFb32.js.map